module.exports = __webpack_public_path__ + "assets/img/sabc_contact_form_capcha.webp?ac87b6f7bbef1492dfa327896c397a28";